import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';

import { CampaignService } from './services';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CampaignGuard implements CanActivate {
  constructor(
    public campaignService: CampaignService
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      this.campaignService.sendLoaderNoInterceptor(true);
      const offerId = route.queryParams["o"];
      const operationId = route.queryParams["operation_id"];
      let qParams: string = sessionStorage.getItem("queryParams");
      if (Object.keys(route.queryParams).length && !qParams) {
        sessionStorage.setItem("queryParams", JSON.stringify(route.queryParams));
      }
      let dataDraft: any;
      let saleStatus = this.campaignService.getSaleStatus();
      if (saleStatus.type !== CampaignService.SALE_TYPES.VL) {
        this.campaignService.sendLoaderNoInterceptor(false);
        const fullCampaign: any = this.campaignService.getData();
        if (fullCampaign?.offer_id || fullCampaign?.id_offer) {
          return true;
        } else {
          const sessionOpId: any = sessionStorage.getItem("chubbData_front");
          const sessionQParams = JSON.parse(sessionStorage.getItem("queryParams"));
          this.campaignService.setSaleStatus({
            type: CampaignService.SALE_TYPES.VC,
            operationId: operationId || sessionOpId.operation_id || sessionQParams.operation_id,
          });
          dataDraft = {
            type: CampaignService.SALE_TYPES.VC,
            operation_id: operationId || sessionOpId.operation_id || sessionQParams.operation_id,
          };
          this.campaignService.sendLoaderNoInterceptor(false);
          this.campaignService.loadCampaign(dataDraft);
          return true;
        }
      }
      if (offerId) {
        this.campaignService.setSaleStatus({ type: CampaignService.SALE_TYPES.VS, offer_id: offerId });
        dataDraft = {
          type: CampaignService.SALE_TYPES.VS,
          ramo_name: null,
          coverage_name: null,
          data: {
            id_offer: offerId,
          },
          str_UTM: {
            ...JSON.parse(qParams),
            ...route.queryParams,
          },
        };
        this.campaignService.sendLoaderNoInterceptor(false);
        this.campaignService.loadCampaign(dataDraft);
        return true;
      }
      if (operationId) {
        this.campaignService.setSaleStatus({
          type: CampaignService.SALE_TYPES.VC,
          operationId: operationId,
        });
        dataDraft = {
          type: CampaignService.SALE_TYPES.VC,
          operation_id: operationId,
          str_UTM: {
            ...JSON.parse(qParams),
            ...route.queryParams,
          },
        };
        this.campaignService.sendLoaderNoInterceptor(false);
        this.campaignService.loadCampaign(dataDraft);
        return true;
      }
      const campaignData = this.campaignService.getData();
      this.campaignService.sendLoaderNoInterceptor(false);
      return true;
  }
  
}
